import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["masterTracking", "applyInput", "lineTracking"]

  connect() {
    this.syncApplyField()
  }

  syncApplyField() {
    if (!this.hasApplyInputTarget) return
    const value = (this.masterTrackingTarget?.value || "").trim()
    this.applyInputTarget.value = value.length > 0 ? "1" : "0"
  }

  propagateTracking(event) {
    this.syncApplyField()
    const value = (this.masterTrackingTarget?.value || "").trim()
    if (!value.length) return
    this.lineTrackingTargets.forEach((input) => {
      input.value = value
    })
  }
}
